import {http} from '../../shared/services';

export const LOAD_FILTERS = 'LOAD_FILTERS';
export const LOAD_FILTERS_PENDING = `${LOAD_FILTERS}_PENDING`;
export const LOAD_FILTERS_FULFILLED = `${LOAD_FILTERS}_FULFILLED`;
export const LOAD_FILTERS_REJECTED = `${LOAD_FILTERS}_REJECTED`;

export function loadFilters(characterId) {
  return {
    type: LOAD_FILTERS,
    payload: http.get('filters'),
  };
}



// WEBPACK FOOTER //
// ./app/features/characterDetail/actions/loadFilters.js